{
  "032062c35f0ec6c7": "Failed to load referrals.",
  "0355dadf5f4baffe": "Track when your contact signs up their workplace using your referral code.",
  "039f155d5e0eb4bc": "Referral Earned",
  "098f25dceaa93fbd": "Send referral",
  "0faec61d36bda7bd": "Sign up to Clipboard Health using my referral link!",
  "117fe58fb0965b3b": "Failed to load referral code.",
  "11fc1404d2a4c96f": "Send your personalized referral link to your workplace contacts.",
  "25d092234974cd8b": "Introduce your workplace contacts to Clipboard Health by sending them your referral link.",
  "3d44337010bfbdf7": "Created At",
  "4258c29ea4d12fbe": "Refer a new workplace",
  "596f52c9bbfdeb6f": "Outlook / Hotmail / Live",
  "5dbfc76de9a61cb2": "Admin view",
  "61cefb5ee7454e7d": "Incentive: {{incentive}}",
  "664b0a5c07ecbd94": "Referral bonus",
  "6fa2f04b36ca4a14": "Read the terms and program requirements.",
  "76ffc344c6ae80b5": "Referrals",
  "7cdc830f14ab65a1": "Shift credits",
  "86a5bfa5d2dc25ff": "Share the referral link",
  "89f8087ecd480ef3": "Track your referrals",
  "920e413c7d411b61": "Status",
  "942087cc2d41e013": "Retry",
  "969ccbd3cf6300ec": "Email",
  "a1630b6d262decc2": "Workplace name",
  "ad6f1f46a0d887fa": "Earn your referral!",
  "bd2ba12499df5239": "Share your referral link",
  "c193a5735f1723aa": "Hi!\n\nI've been using Clipboard Health and finding it super helpful for getting access to reliable shift coverage. The signup is seamless and the app is super easy to use.\n\nI think you should sign up to Clipboard Health. I find it to be super helpful for accessing reliable shift coverage. You get access to Professional ETA, in-app chat, urgent shift replacement and more!\n\nSign up using my referral code and you'll instantly earn {{incentiveAmount}} credits once you post your first shift (the credits will apply to the first shift onward): {{referralUrl}}\n\nI think you're going to be in for a treat!\n\nAll the best,\n\n{{fullName}}",
  "d19a15c70437ed6e": "Gmail",
  "d637a2187ef38917": "Send your referral link to other workplaces. You can also copy the link and share it via social media or text.",
  "dbf362d4f210c780": "Copy link",
  "dc634dfbcce23ba4": "No referrals yet",
  "dcd1d5223f73b3a9": "Name",
  "ea61bc15688d1e48": "Copied!",
  "f408535bacccfc1d": "Referral Code",
  "fe17ed8e33cb2efd": "Variant: {{variant}}"
}
